import { RefBuilder } from "@max/common/dist/firestore";
import { collection, doc, getFirestore } from "firebase/firestore";

export const Ref = RefBuilder({
  collection: collection,
  doc: doc,
  getFirestore: getFirestore,
});
